import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle",
      animation: 150,
      onEnd: (event) => {
        const id = event.item.dataset.statusId
        const position = event.newIndex
        this.submitReorder(id, position)
      }
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  submitReorder(id, position) {
    fetch(`/issue_statuses/${id}/reorder`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken
      },
      body: JSON.stringify({ position })
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
